var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{on:{"click":function($event){return _vm.$emit('click')}}},[_c('font-awesome-icon',{class:{ 'star-selected': _vm.isFollowed, pointer: _vm.isFollowed || !_vm.isFollowed },attrs:{"icon":_vm.isFollowed ? ['fas', 'star'] : ['far', 'star']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }